import React, { useCallback } from 'react';

import Icon from '../Icon';
import Typography from '../Typography';

/**
 * REACT CheckBox component
 * it has two props, checked and onChange
 * checked is a boolean value
 * onChange is a function that will be called when the checkbox is clicked
 *
 * CheckBox is a component that allows you to use as a boolean
 */

interface CheckBoxProps {
	checked: boolean;
	onChange: (state: boolean) => void;
	className?: string;
	label: string;
	labelClassName?: string;
	labelVariant?: 'body' | 'button' | 'caption' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle' | 'overline' | 'srOnly' | 'inherit';
	disabled?: boolean;
}

const CheckBox: React.FC<CheckBoxProps> = ({
	checked,
	onChange,
	label,
	labelClassName,
	labelVariant = 'body',
	className,
	disabled = false,
}) => {
	const handleClick = useCallback(() => {
		if (!disabled) {
			onChange(!checked);
		}
	}, [disabled, checked, onChange]);

	return (
		<div
			className={`flex cursor-pointer items-center space-x-1${className ? className : ''}`}
			onClick={handleClick}
			role="checkbox"
			aria-checked={checked}
		>
			<Icon
				name={checked ? 'checkbox-checked' : 'checkbox-unchecked'}
				className={`${checked ? 'fill-primary-active stroke-primary-active hover:fill-primary-light hover:stroke-primary-light' : ''} h-4 w-4`}
			/>

			<Typography variant={labelVariant ?? 'subtitle'} component="p" className={labelClassName ?? 'text-sm text-white'}>
				{label}
			</Typography>
		</div>
	);
};

export default CheckBox;
